
// import React, { useState } from 'react';
// import axios from 'axios';
// import { toast } from 'react-toastify';
// import { useParams, useNavigate } from 'react-router-dom';
// import AppFooter from '../AppFooter'
// import { FaCamera, FaUpload, FaTimes, FaPlus, FaHome } from 'react-icons/fa';

// function UserAdd() {
//   const { tenant } = useParams(); // Extract tenantId from the URL
//   const [username, setUsername] = useState('');
//   const [email, setEmail] = useState('');
//   const [firstName, setFirstName] = useState('');
//   const [lastName, setLastName] = useState('');
//   const [phone, setPhone] = useState('');
//   const [password, setPassword] = useState('');
//   const [registerStatus, setRegisterStatus] = useState('');
//   const [role, setRole] = useState('manager');

//   const navigate = useNavigate();
//   const notifySuccess = (message) => toast.success(message);
//   const notifyError = (message) => toast.error(message);

//   const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

//   const registerUser = (e) => {
//     e.preventDefault();
//     axios
//       .post(`${baseUrl}/api/tenants/${tenant}/registeruser`, {
//         username,
//         email,
//         firstname: firstName,
//         lastname: lastName,
//         phone,
//         password,
//         role,
//       })
//       .then((response) => {
//         // if (response.data.message) {
//         if (response.status === 201) {
//           notifySuccess('Account created successfully!');
//           setUsername('');
//           setEmail('');
//           setFirstName('');
//           setLastName('');
//           setPhone('');
//           setPassword('');
//           navigate(`/${tenant}/dashboard`);
//         } else {
//           notifyError(response.data.message);
//         }
//       })
//       .catch((error) => {
//         console.error(error);
//         const msg = error?.response?.data?.message || 'An error occurred while creating the account.';
//         notifyError(msg);
//       });
//   };

//   const handleDashboard = () => {
//     navigate(`/${tenant}/dashboard`);
//   };
  

// return (
//   <div className="container">
//     <h2 className="hdr hdr--primary hdr--lg">Create Account</h2>
//     <form onSubmit={registerUser}>
//       <div className="form-group">
//         <label htmlFor="username">Username</label>
//           <input
//             className="textInput"
//             type="text"
//             name="username"
//             onChange={(e) => setUsername(e.target.value)}
//             placeholder="Username"
//             required
//           />
//       </div>
//       <div className="form-group">
//           <label htmlFor="firstName">First Name</label>
//           <input
//             className="textInput"
//             type="text"
//             name="firstName"
//             onChange={(e) => setFirstName(e.target.value)}
//             placeholder="First Name"
//             required
//           />
//       </div>
//       <div className="form-group">
//           <label htmlFor="lastName">Last Name</label>
//           <input
//             className="textInput"
//             type="text"
//             name="lastName"
//             onChange={(e) => setLastName(e.target.value)}
//             placeholder="Last Name"
//             required
//           />
//       </div>
//       <div className="form-group">
//           <label htmlFor="email">Email Address</label>
//           <input
//             className="textInput"
//             type="text"
//             name="email"
//             onChange={(e) => setEmail(e.target.value)}
//             placeholder="Enter your Email Address"
//             required
//           />
//       </div>
//       <div className="form-group">
//           <label htmlFor="phone">Phone</label>
//           <input
//             className="textInput"
//             type="text"
//             name="phone"
//             onChange={(e) => setPhone(e.target.value)}
//             placeholder="Enter your Phone Number"
//             required
//           />
//       </div>
//       <div className="form-group">
//           <label htmlFor="password">Password</label>
//           <input
//               type="password"
//               id="password"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="Password"
//               required
//           />
//       </div>
//       <div className="form-group">
//         <label>Role</label>
//         <select className="textInput" value={role} onChange={(e)=>setRole(e.target.value)}>
//           <option value="admin">Admin</option>
//           <option value="manager">Manager</option>
//           <option value="operator">Operator</option>
//         </select>
//       </div>
//       {/* {registerStatus && <p className="status-message">{registerStatus}</p>} */}
//       </form>
//       <AppFooter
//         buttons={[
//           {
//             icon: <FaHome />,
//             label: 'Home',
//             onClick: handleDashboard,
//           },
//           {
//             icon: <FaPlus />,
//             label: 'Create',
//             onClick: registerUser,
//             type: 'submit'
//           },
//         ]}
//       />
//     </div>
//   );
// }

// export default UserAdd;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import AppFooter from '../AppFooter'
import { FaCamera, FaUpload, FaTimes, FaPlus, FaHome, FaExclamationTriangle } from 'react-icons/fa';

function UserAdd() {
  const { tenant } = useParams(); // Extract tenantId from the URL
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [registerStatus, setRegisterStatus] = useState('');
  const [role, setRole] = useState('manager');
  
  // ⭐ New state for user limit checking
  const [userLimitInfo, setUserLimitInfo] = useState(null);
  const [canAddUser, setCanAddUser] = useState(true);
  const [isCheckingLimit, setIsCheckingLimit] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  const notifySuccess = (message) => toast.success(message);
  const notifyError = (message) => toast.error(message);

  const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:5000';

  // ⭐ New: Check user limit when component mounts
  useEffect(() => {
    checkUserLimit();
  }, [tenant]);

  /**
   * ⭐ New function: Check if tenant can add more users
   */
  const checkUserLimit = async () => {
    setIsCheckingLimit(true);
    try {
      const response = await axios.get(`${baseUrl}/api/tenants/${tenant}/can-add-user`);
      
      if (response.data.success) {
        setUserLimitInfo({
          currentUsers: response.data.currentUsers,
          maxUsers: response.data.maxUsers,
          message: response.data.message
        });
        setCanAddUser(response.data.canAdd);
        
        if (!response.data.canAdd) {
          notifyError(response.data.message);
        }
      }
    } catch (error) {
      console.error('Error checking user limit:', error);
      // On error, allow the form (fail open for better UX)
      setCanAddUser(true);
    } finally {
      setIsCheckingLimit(false);
    }
  };

  const registerUser = async (e) => {
    e.preventDefault();
    
    // ⭐ Double-check user limit before submitting
    if (!canAddUser) {
      notifyError('Cannot add more users. Please upgrade your plan.');
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await axios.post(`${baseUrl}/api/tenants/${tenant}/registeruser`, {
        username,
        email,
        firstname: firstName,
        lastname: lastName,
        phone,
        password,
        role,
      });
      
      if (response.status === 201) {
        notifySuccess('Account created successfully!');
        
        // ⭐ Update user limit info if provided in response
        if (response.data.userLimitInfo) {
          setUserLimitInfo({
            currentUsers: response.data.userLimitInfo.currentUsers,
            maxUsers: response.data.userLimitInfo.maxUsers,
            message: `${response.data.userLimitInfo.currentUsers}/${response.data.userLimitInfo.maxUsers} users created`
          });
        }
        
        // Clear form
        setUsername('');
        setEmail('');
        setFirstName('');
        setLastName('');
        setPhone('');
        setPassword('');
        
        // Navigate back to dashboard
        navigate(`/${tenant}/dashboard`);
      } else {
        notifyError(response.data.message);
      }
    } catch (error) {
      console.error(error);
      
      // ⭐ Handle specific error cases
      if (error.response?.status === 403) {
        // User limit reached
        const errorData = error.response.data;
        notifyError(errorData.message || 'User limit reached');
        setCanAddUser(false);
        
        if (errorData.details) {
          setUserLimitInfo({
            currentUsers: errorData.details.currentUsers,
            maxUsers: errorData.details.maxUsers,
            message: errorData.message
          });
        }
      } else {
        const msg = error?.response?.data?.message || 'An error occurred while creating the account.';
        notifyError(msg);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDashboard = () => {
    navigate(`/${tenant}/dashboard`);
  };

  /**
   * ⭐ New function: Handle upgrade plan click
   * You can customize this to navigate to your pricing page or show a modal
   */
  const handleUpgrade = () => {
    // Navigate to upgrade/pricing page or show modal
    toast.info('Please contact support to upgrade your plan');
    // navigate(`/${tenant}/settings/billing`); // Example route
  };

  // ⭐ Show loading state while checking limit
  if (isCheckingLimit) {
    return (
      <div className="container">
        <h2 className="hdr hdr--primary hdr--lg">Create Account</h2>
        <div className="text-center p-4">
          <p>Checking user limit...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <h2 className="hdr hdr--primary hdr--lg">Create Account</h2>
      
      {/* ⭐ New: User limit warning banner */}
      {userLimitInfo && userLimitInfo.maxUsers > 0 && (
        <div className={`alert ${canAddUser ? 'alert-info' : 'alert-warning'} mb-3`}>
          <div className="d-flex align-items-center">
            {!canAddUser && <FaExclamationTriangle className="mr-2" />}
            <div className="flex-grow-1">
              <strong>User Limit: </strong>
              {userLimitInfo.message}
              {!canAddUser && (
                <p className="mb-0 mt-1">
                  <small>
                    You've reached your user limit. 
                    <button 
                      onClick={handleUpgrade}
                      className="btn btn-link btn-sm p-0 ml-1"
                      style={{ textDecoration: 'underline' }}
                    >
                      Upgrade your plan
                    </button>
                    {' '}to add more users.
                  </small>
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      <form onSubmit={registerUser}>
        <div className="form-group">
          <label htmlFor="username">Username</label>
            <input
              className="textInput"
              type="text"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Username"
              required
              disabled={!canAddUser || isSubmitting}
            />
        </div>
        <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input
              className="textInput"
              type="text"
              name="firstName"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="First Name"
              required
              disabled={!canAddUser || isSubmitting}
            />
        </div>
        <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input
              className="textInput"
              type="text"
              name="lastName"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Last Name"
              required
              disabled={!canAddUser || isSubmitting}
            />
        </div>
        <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              className="textInput"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your Email Address"
              required
              disabled={!canAddUser || isSubmitting}
            />
        </div>
        <div className="form-group">
            <label htmlFor="phone">Phone</label>
            <input
              className="textInput"
              type="text"
              name="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Enter your Phone Number"
              required
              disabled={!canAddUser || isSubmitting}
            />
        </div>
        <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
                type="password"
                id="password"
                className="textInput"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                required
                disabled={!canAddUser || isSubmitting}
            />
        </div>
        <div className="form-group">
          <label>Role</label>
          <select 
            className="textInput" 
            value={role} 
            onChange={(e)=>setRole(e.target.value)}
            disabled={!canAddUser || isSubmitting}
          >
            <option value="admin">Admin</option>
            <option value="manager">Manager</option>
            <option value="operator">Operator</option>
          </select>
        </div>
        {/* {registerStatus && <p className="status-message">{registerStatus}</p>} */}
      </form>
      
      <AppFooter
        buttons={[
          {
            icon: <FaHome />,
            label: 'Home',
            onClick: handleDashboard,
            disabled: isSubmitting
          },
          {
            icon: <FaPlus />,
            label: isSubmitting ? 'Creating...' : 'Create',
            onClick: registerUser,
            type: 'submit',
            disabled: !canAddUser || isSubmitting
          },
        ]}
      />
    </div>
  );
}

export default UserAdd;